import { Link } from 'react-router-dom';
import type { AuditEntry } from '../lib/api';
import { actionLabel, formatDateTime } from '../lib/format';
import { moduleLabel } from '../lib/moduleCatalog';
import { Card } from './ui';

function detailsText(entry: AuditEntry): string | null {
  const d = entry.details;
  if (!d) return null;
  if (typeof d.reason === 'string') return d.reason;
  if (typeof d.number === 'string') return `Factura ${d.number}`;
  if (typeof d.domain === 'string') return d.domain;
  if (entry.action === 'tenant.modules') {
    if (d.allowed === null) return 'toate modulele';
    const list = (key: string) =>
      Array.isArray(d[key]) ? (d[key] as string[]).map(moduleLabel).join(', ') : '';
    const parts = [
      list('added') && `pornite: ${list('added')}`,
      list('removed') && `oprite: ${list('removed')}`,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(' · ') : 'listă restrânsă de module';
  }
  if (entry.action === 'tenant.optInModules') {
    const list = (key: string) =>
      Array.isArray(d[key]) ? (d[key] as string[]).map(moduleLabel).join(', ') : '';
    const parts = [
      list('added') && `acordate: ${list('added')}`,
      list('removed') && `retrase: ${list('removed')}`,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(' · ') : 'fără schimbări';
  }
  return null;
}

export function AuditList({
  entries,
  showTenant,
}: {
  entries: AuditEntry[];
  showTenant?: boolean;
}) {
  return (
    <Card className="p-0">
      <ul className="divide-y divide-slate-800/70">
        {entries.map((e) => (
          <li
            key={e.id}
            className="flex flex-wrap items-baseline gap-x-3 gap-y-1 px-4 py-3 text-sm"
          >
            <span className="w-32 shrink-0 text-xs text-slate-500">{formatDateTime(e.at)}</span>
            <span className="font-medium text-white">{actionLabel(e.action)}</span>
            {showTenant && e.tenant && (
              <Link
                to={`/tenants/${e.tenant.id}`}
                className="text-violet-300 hover:text-violet-200"
              >
                {e.tenant.name}
              </Link>
            )}
            {detailsText(e) && <span className="text-slate-400">{detailsText(e)}</span>}
            <span className="ml-auto text-xs text-slate-500">{e.operator?.name ?? 'sistem'}</span>
          </li>
        ))}
        {entries.length === 0 && (
          <li className="px-4 py-8 text-center text-sm text-slate-400">
            Nicio acțiune înregistrată.
          </li>
        )}
      </ul>
    </Card>
  );
}
